import ConfirmationScreen from "./veiculo/ConfirmationScreen";
import FormularioCompleto from "./veiculo/FormularioCompleto";
import { useVeiculoOrchestrator } from "../hooks/useVeiculoOrchestrator";
import { AccessDeniedModal, SuccessModal, ErrorToast } from "./veiculo/Modals";
import { Loader2 } from "lucide-react";

const VeiculoForm = () => {
  const {
    caseData,
    isAlreadyAnswered,
    userConfirmed,
    timeLeft,
    isExpired,
    modalInfo,
    errorInfo,
    handleReject,
    handleConfirm,
    handleSubmit,
    handleSuccessAction,
    displayError,
  } = useVeiculoOrchestrator();

  if (isAlreadyAnswered) {
    return <AccessDeniedModal />;
  }
  // Enquanto os dados não chegam, caseData é nulo, e a tela de confirmação não é mostrada.
  // Assim que chegam, verificamos se 'confirmado_em' existe.
  const showConfirmationScreen = !caseData?.confirmado_em;

  // Renderiza um loader enquanto os dados do caso estão a ser carregados
  if (!caseData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader2 className="h-12 w-12 animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-neutral-100 rounded-lg shadow-lg p-4 md:p-8 border border-slate-400">
      <div className="text-center mb-8">
        <h1 className="flex flex-col items-center text-3xl md:text-3xl font-bold text-gray-700">
          <div>Veículo Encontrado</div>
          <div className="text-2xl mt-2 text-gray-600">
            {caseData ? (
              <span>{caseData.escritorio.nome}</span>
            ) : (
              <Loader2 className="h-8 w-8 animate-spin" />
            )}
          </div>
        </h1>
      </div>

      {showConfirmationScreen ? (
        <ConfirmationScreen
          onConfirm={handleConfirm}
          onReject={handleReject}
          placa={caseData?.placa}
        />
      ) : (
        <FormularioCompleto
          caseData={caseData}
          timeLeft={timeLeft}
          isExpired={isExpired}
          onSubmit={handleSubmit}
          displayError={displayError}
        />
      )}

      <ErrorToast message={errorInfo.message} show={errorInfo.show} />

      {modalInfo.show && (
        <SuccessModal modalInfo={modalInfo} onClose={handleSuccessAction} />
      )}
    </div>
  );
};

export default VeiculoForm;
